__turbopack_context__.v({
  "banner": "_4y8KVa_banner",
  "body": "_4y8KVa_body",
  "body2": "_4y8KVa_body2",
  "header": "_4y8KVa_header",
  "sectionHeader": "_4y8KVa_sectionHeader",
  "sectionHeader2": "_4y8KVa_sectionHeader2",
  "subtitle": "_4y8KVa_subtitle",
  "subtitle2": "_4y8KVa_subtitle2",
  "title": "_4y8KVa_title",
  "title2": "_4y8KVa_title2",
  "top": "_4y8KVa_top",
  "top2": "_4y8KVa_top2",
  "top3": "_4y8KVa_top3",
});
